// extracted by mini-css-extract-plugin
module.exports = {"iconpark-icon":"__3cMLC","iconparkIcon":"__3cMLC"};